export const validateName ="^[a-zA-Z][a-zA-Z .,'-]*$";
export const validatePhoneNo="^[0-9]{10}$";
export const validateRounds="^[0-9]{1,3}$";
export const validateEmail='[a-z0-9]+@[a-z]+\.[a-z]{2,3}$';
export const validateAddress="^[a-zA-Z0-9][a-zA-Z0-9 .,'-]*$";